import { render } from "./search-variants.vue?vue&type=template&id=1ec841b1"
import script from "./search-variants.vue?vue&type=script&lang=js"
export * from "./search-variants.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__